import React, { useState, useEffect } from "react";
import { StyleSheet } from "react-native";

import AppConfig from "../../../../config/AppConfig";
import AppTheme from "../../AppTheme";

import Dialog from "../dialog";
import EmojiPicker from "./EmojiPicker";

export default function ManaEmojiPicker({
  isOpen = false,
  onConfirm = () => {},
  onClose = () => {},
  autoFocus = null
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    setIsDialogOpen(isOpen);
  }, [isOpen]);

  const confirmPickerValue = (emoji) => {
    if (onConfirm && emoji) {
      onConfirm(emoji);
    }

    onClose();
  };
  return (
    <>
      {isDialogOpen ? (
        <Dialog.Container style={styles.container} onClose={onClose}>
          <EmojiPicker selectEmoji={(emoji) => confirmPickerValue(emoji)} />

          <Dialog.Button
            style={styles.cancelButton}
            label="Close"
            onPress={onClose}
          />
        </Dialog.Container>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
  },
  cancelButton: {
    textAlign: "center",
    fontSize: 18,
    color: AppTheme.DEFAULT_COLOR,
    backgroundColor: "white",
  },
});
